/* eslint-disable no-console */
import axios from 'axios';
import { api } from '../config';
import store from '../store';
import { quickDecrypt } from '../utils/crypto';
import { forceLogout, getSessionEndCode } from './sessionManager';

// Set baseURL global
axios.defaults.baseURL = api.API_URL;
axios.defaults.withCredentials = true;
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.xsrfHeaderName = 'X-XSRF-TOKEN';

// Set Content-Type untuk POST
axios.defaults.headers.post['Content-Type'] = 'application/json';

// ✅ Ambil token dari Redux state (gunakan saat HYDRATED)

export const getTokenFromRedux = () => {
  try {
    const state = store.getState();
    const token = state?.Login?.user?.token || null;

    if (token && typeof token === 'string' && token.trim() !== '') {
      return token;
    }

    return null;
  } catch (error) {
    console.error('Gagal ambil token dari Redux:', error);
    return null;
  }
};

// ✅ Tambahkan Interceptor REQUEST
axios.interceptors.request.use(
  config => {
    const token = getTokenFromRedux();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  error => Promise.reject(error)
);

// ✅ Tambahkan Interceptor RESPONSE
axios.interceptors.response.use(
  response => (response?.data ? response.data : response),
  error => {
    const status = error?.response?.status;
    // Deteksi kode sesi SEBELUM error diubah jadi string (body 401 dari BE: data.code).
    const sessionCode = getSessionEndCode(status, error?.response?.data);
    if (sessionCode) {
      forceLogout(sessionCode);
      return Promise.reject('Session ended');
    }
    let message = 'Terjadi kesalahan.';

    switch (status) {
      case 500:
        message = 'Internal Server Error';
        break;
      case 401:
        // 401 tanpa kode sesi (mis. controller Unauthorized("...")) tidak me-logout.
        message = 'Unauthorized - Token tidak valid atau habis';
        break;
      case 404:
        message = 'Data tidak ditemukan';
        break;
      default:
        message = error?.response?.data?.message || error.message;
    }

    return Promise.reject(message);
  }
);

// ✅ Fungsi untuk set token manual (misal setelah login)
export const setAuthorization = token => {
  axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
};

// ✅ Class APIClient
class APIClient {
  get(url, params) {
    const query =
      params && Object.keys(params).length
        ? '?' +
          Object.entries(params)
            .map(([key, val]) => `${key}=${val}`)
            .join('&')
        : '';
    return axios.get(`${url}${query}`);
  }

  create(url, data) {
    return axios.post(url, data);
  }

  update(url, data) {
    return axios.patch(url, data);
  }

  put(url, data) {
    return axios.put(url, data);
  }

  delete(url, config = {}) {
    return axios.delete(url, { ...config });
  }
}

// const getLoggedinUser1 = () => {
//   try {
//     // First try to get from Redux store
//     const state = store.getState();
//     const reduxUser = state?.Login?.user;
//     if (reduxUser) {
//       return reduxUser;
//     }
//     const persistedState = sessionStorage.getItem('persist:root');
//     if (persistedState) {
//       const parsed = JSON.parse(persistedState);
//       const loginState = JSON.parse(parsed.Login || '{}');
//       console.log(loginState?.user);
//       return loginState?.user || null;
//     }

//     return null;
//   } catch (error) {
//     return null;
//   }
// };

const getLoggedinUser = () => {
  try {
    // First try to get from Redux store
    const state = store.getState();
    const reduxUser = state?.Login?.user;
    if (reduxUser) {
      return reduxUser;
    }
    const persistedState = localStorage.getItem('persist:root');
    if (persistedState) {
      const parsed = JSON.parse(persistedState);
      const loginState = quickDecrypt(parsed.Login || '{}');
      //console.log('token 1', loginState?.user);
      return loginState?.user || null;
    }

    return null;
  } catch (error) {
    return null;
  }
};

//  const loginState = quickDecrypt(parsed.Login || '{}');
//  console.log('data log', loginState?.user);

export { APIClient, getLoggedinUser };
